export const DEFAULT_GOOGLE_RATING = {
  enabled: true,
  rating: 4.6,
  reviewCount: 15,
  url: 'https://www.google.com/maps/search/?api=1&query=Yal%C3%A7%C4%B1n%20End%C3%BCstriyel%20Temizlik%20Malzemeleri%20%C4%B0sto%C3%A7'
};

export const normalizeGoogleRating = (value = {}) => {
  const rating = Number(value.rating);
  const reviewCount = Number.parseInt(value.reviewCount, 10);
  const url = String(value.url || '').trim();

  return {
    enabled: value.enabled !== false,
    rating: Number.isFinite(rating)
      ? Math.min(5, Math.max(0, Math.round(rating * 10) / 10))
      : DEFAULT_GOOGLE_RATING.rating,
    reviewCount: Number.isFinite(reviewCount) && reviewCount >= 0
      ? reviewCount
      : DEFAULT_GOOGLE_RATING.reviewCount,
    url: url || DEFAULT_GOOGLE_RATING.url
  };
};
